import { TypeVas } from '../../interfaces/TypeVas/TypeVas'
import { typeVasActionTypes } from '../types/typeVasActionTypes'

export type TypeVasActions = TypeVasAction | TypeVasActionAsync

export interface TypeVasAction {
  type: typeof typeVasActionTypes.GET_TYPE_VAS_EXITO
  typeVas: TypeVas[] | undefined
  error: string | undefined
}

export const getTypeVasAction = (
  typeVas?: TypeVas[],
  error?: string
): TypeVasAction => {
  return {
    type: typeVasActionTypes.GET_TYPE_VAS_EXITO,
    typeVas,
    error
  }
}

// Esto va a SAGA
export interface TypeVasActionAsync {
  type: typeof typeVasActionTypes.GET_TYPE_VAS
}

export const getTypeVasActionAsync = (): TypeVasActionAsync => {
  return {
    type: typeVasActionTypes.GET_TYPE_VAS
  }
}
